<template>
  <b-row>
    <b-col cols="12">
      <AttendanceMusterViewForm />
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from "bootstrap-vue";
import AttendanceMusterViewForm from "./AttendanceMusterViewForm.vue";

export default {
  components: {
    BRow,
    BCol,
    AttendanceMusterViewForm,
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-wizard.scss";
@import "@core/scss/vue/libs/vue-select.scss";
</style>
